import React, { useEffect, useState, Fragment } from 'react';
import { AlarmClock } from 'lucide-react';
function remaining(target: number) {
  return Math.max(0, target - Date.now());
}
export function CountdownTimer() {
  const [target, setTarget] = useState(0);
  const [time, setTime] = useState(86400000);
  useEffect(() => {
    const saved = Number(localStorage.getItem('mp_countdown_target'));
    const next = saved > Date.now() ? saved : Date.now() + 86400000;
    localStorage.setItem('mp_countdown_target', String(next));
    setTarget(next);
  }, []);
  useEffect(() => {
    if (!target) return;
    const id = window.setInterval(() => {
      const next = remaining(target);
      if (!next) {
        const reset = Date.now() + 86400000;
        localStorage.setItem('mp_countdown_target', String(reset));
        setTarget(reset);
      } else setTime(next);
    }, 1000);
    return () => clearInterval(id);
  }, [target]);
  const v = [Math.floor(time / 3600000), Math.floor(time / 60000) % 60, Math.floor(time / 1000) % 60];
  return <aside aria-label="Oferta por tiempo limitado" className="mx-auto mt-10 max-w-3xl rounded-2xl border border-red-500/40 bg-[#1a0404] p-6 text-center shadow-[0_0_30px_rgba(239,68,68,.13)]" data-id="element-39">
      <p className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide text-red-400" data-id="element-40">
        <AlarmClock size={19} data-id="element-41" />
        El precio de lanzamiento termina en:
      </p>
      <div className="my-6 flex items-center justify-center gap-2 sm:gap-4" data-id="element-42">
        {v.map((n, i) => <Fragment key={i} data-id="element-43">
            <div className="min-w-[76px] rounded-xl border-2 border-red-500/40 bg-black px-3 py-3" data-id="element-44">
              <b className="text-3xl tabular-nums sm:text-5xl" data-id="element-45">
                {String(n).padStart(2, '0')}
              </b>
              <small className="ml-1 text-red-300" data-id="element-46">
                {['hs', 'min', 'seg'][i]}
              </small>
            </div>
            {i < 2 && <b className="text-3xl text-red-400" data-id="element-47">:</b>}
          </Fragment>)}
      </div>
      <p className="text-xs font-bold uppercase tracking-wide text-gray-200" data-id="element-48">
        Después sube el precio y no vuelve a bajar.
      </p>
    </aside>;
}